import React from 'react';
import { TextInput, NumberInput, CheckBox } from 'hyperdb-utils';

const RUFields = ({ settings, onChange, checkboxesToDisplay = [] }) => {
  const handleClickCheckbox = (attributeName) => {
    const checked = !settings[attributeName];
    onChange(attributeName, { value: checked });
  };
  return (
    <div>
      <TextInput
        label="Local login"
        name="local_login"
        value={ settings.local_login }
        onChange={ onChange.bind(null, 'local_login') }
      />
      <TextInput
        label="Local password"
        name="local_password"
        value={ settings.local_password }
        onChange={ onChange.bind(null, 'local_password') }
      />
      <TextInput
        label="Remote login"
        name="remote_login"
        value={ settings.remote_login }
        onChange={ onChange.bind(null, 'remote_login') }
      />
      <TextInput
        label="Remote password"
        name="remote_password"
        value={ settings.remote_password }
        onChange={ onChange.bind(null, 'remote_password') }
      />
      <NumberInput
        label="Price ratio"
        name="price_ratio"
        value={ settings.price_ratio }
        onChange={ onChange.bind(null, 'price_ratio') }
      />
      <fieldset>
        <legend>Owner</legend>
        <TextInput
          label="First name"
          name="owner_first_name"
          value={ settings.owner_first_name }
          onChange={ onChange.bind(null, 'owner_first_name') }
        />
        <TextInput
          label="Last name"
          name="owner_last_name"
          value={ settings.owner_last_name }
          onChange={ onChange.bind(null, 'owner_last_name') }
        />
        <TextInput
          label="Email"
          name="owner_email"
          value={ settings.owner_email }
          onChange={ onChange.bind(null, 'owner_email') }
        />
        <TextInput
          label="Phone"
          name="owner_phone"
          value={ settings.owner_phone }
          onChange={ onChange.bind(null, 'owner_phone') }
        />
      </fieldset>
      <div>
        {
          checkboxesToDisplay.map((checkbox, i) => {
            return (
              <CheckBox
                label={ checkbox }
                name={ checkbox }
                checked={ settings[checkbox] }
                onChange={ handleClickCheckbox.bind(null, checkbox) }
              />
            );
          })
        }
      </div>
    </div>
  );
};

export default RUFields;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/channel/components/RUFields.jsx